import token from 'styled-token';
import { clearFixMixin } from '../clearFixMixin';

/** @class PageMixin */
/** @method */
export var PageMixin = function PageMixin(props) {
  var backgroundToken = 'Page.backgroundColor';
  if (typeof props.backgroundColor !== 'undefined') {
    backgroundToken = "colors." + props.backgroundColor;
  }
  return token(backgroundToken, function (backgroundColor) {
    var styles = [clearFixMixin(props)];
    if (backgroundColor) {
      styles.push("background-color: " + backgroundColor + ";");
    }
    return styles;
  })(props);
};